export function getActivityBySpark(
  spark: SparkEntity,
  activities: (ActivityEntity | undefined)[] | undefined,
  trainings: (TrainingEntity | undefined)[] | undefined,
  assessment?: AssessmentEntity
): Array<{ name: string; type: 'activity' | 'training' }> {
  const activityResults: Array<{ name: string; type: 'activity' }> = [];
  const trainingResults: Array<{ name: string; type: 'training' }> = [];

  // Extract process_id from matching reflections
  const processIds = spark.process_ids;

  // Find processes with matching ids in assessment project
  const matchingProcesses = assessment?.project.process.filter((process) =>
    processIds.includes(process.id)
  );

  matchingProcesses?.forEach((process) => {
    if (process.process_type === 'App\\Activity') {
      // Find activity with matching id
      const matchingActivity = activities?.find(
        (activity) => activity?.id === process.process_id
      );

      if (matchingActivity) {
        activityResults.push({
          name: matchingActivity.name,
          type: 'activity',
        });
      }
    } else if (process.process_type === 'App\\Training') {
      // Find training with matching id
      const matchingTraining = trainings?.find(
        (training) => training?.id === process.process_id
      );

      if (matchingTraining) {
        trainingResults.push({
          name: matchingTraining.title,
          type: 'training',
        });
      }
    }
  });

  // Combine activityResults and trainingResults
  const results = [...activityResults, ...trainingResults];

  return results;
}
